import axiosInstance from 'utils/axiosInstance';
import { TaskType } from '../types';

export const GetTaskDasboard = async (): Promise<ApiResponse<TaskType[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<TaskType[]>>(
    'api/task/GetTasksByStatusType/0',
  );
  return data;
};
